import { useAiAssistantStore } from '@/stores/useAiAssistantStore';
import { useAiTaskQueueStore } from '@/stores/useAiTaskQueueStore';
import { useAiSessionNotifyStore } from '@/stores/useAiSessionNotifyStore';
import { useAppShellStore } from '@/stores/useAppShellStore';
import { clearProjectDetailTabState } from '@/utils/projectDetailTabState';
import { setUserSessionScope } from '@/utils/userSessionScope';
import { useSorAnalyzePollStore } from '@/stores/useSorAnalyzePollStore';
import { useSorAnalyzeControlStore } from '@/stores/useSorAnalyzeControlStore';

/** 登出或切换账号时清理内存中的 UI 与会话状态，避免串号 */
export function resetClientSessionState(
  tenantId?: number | string | null,
  userId?: number | string | null,
): void {
  setUserSessionScope(tenantId, userId);
  useSorAnalyzePollStore().stop();
  useSorAnalyzeControlStore().unregister();
  useAiAssistantStore().resetForUserSwitch();
  useAiTaskQueueStore().resetForUserSwitch();
  useAiSessionNotifyStore().resetForUserSwitch();
  useAppShellStore().resetSessionUiState();
  if (userId == null || userId === '') {
    clearProjectDetailTabState();
  }
}
